import { transformDateValue } from 'core/js/FormUtils';
export const getCampaignView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let campaignList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Audience Name","fieldValue":transformDataValue(data.audiencename,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          campaignList.push(card);
  })
  return campaignList;
}